/**
 * This is the securityquestion routes configuration.
 * Only configure routes in this file.
 * @memberOf securityquestion Module
 * @namespace securityquestion Routes
 */
import registerTemplate from './rsa.register.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf securityquestion Module.securityquestion Routes
 * @ngInject
 */
var config = function ($stateProvider) {

    /* Create the securityquestion state and assign the template and controller. */
    $stateProvider
		.state('login.securityquestion.rsa.register', {
			url: '/register',
			template: registerTemplate,
			controller: 'rsaRegisterController',
			controllerAs: 'vm'
		});
};

export default config;


// WEBPACK FOOTER //
// ./src/login/securityquestion/rsa/register/rsa.register.route.js